export const careerRoutes = [
    {
        path: '/career',
        name: 'career',
        component: () => import('../views/career/Career.vue'),
        meta: {
            title: 'キャリアステップ｜株式会社クレハ 採用サイト'
        }
    },
    {
        path: '/midcareer/staff01',
        name: 'careerStaff01',
        component: () => import('../views/career/Staff01.vue'),
        meta: {
            title: 'キャリア採用 研究開発 菅原一也｜株式会社クレハ 採用サイト'
        }
    },
    {
        path: '/midcareer/staff02',
        name: 'careerStaff02',
        component: () => import('../views/career/Staff02.vue'),
        meta: {
            title: 'キャリア採用 情報システム 光吉雅智｜株式会社クレハ 採用サイト'
        }
    },
    {
        path: '/midcareer/staff03',
        name: 'careerStaff03',
        component: () => import('../views/career/Staff03.vue'),
        meta: {
            title: 'キャリア採用 法務 儀間ゆうな｜株式会社クレハ 採用サイト'
        }
    },
    {
        path: '/midcareer/staff04',
        name: 'careerStaff04',
        component: () => import('../views/career/Staff04.vue'),
        meta: {
            title: 'キャリア採用 設備保全 田子博康｜株式会社クレハ 採用サイト'
        }
    },
]
